import { inject, Injectable } from '@angular/core';
import { ManagedContentItem } from '@app/common-models/managed-content-item';
import { Observable, of } from 'rxjs';
import { LenderService } from '@shared/service/lender/lender.service';

@Injectable({
  providedIn: 'root'
})
export class ManagedContentAppService {
  private readonly lenderService = inject(LenderService);

  /**
   * Gets the static page messaging
   * @param pageName The name of the page - must be well defined or you get null back
   * @returns The page
   */
  public getManagedContentForPage(pageName: string): Observable<ManagedContentItem> {
    return of(this.lenderService?.lenderDataInfo?.managedContents?.find((m) => m.type === pageName));
  }
}
